module.exports = __webpack_public_path__ + "assets/webgl/art_069_L0.jpg.1b536cde.webp";